import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import ReportListItem from "./ReportListItem";
import ReportRecentListItem from "./ReportRecentListItem";

export default class ReportRecentList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      search: [],
      filters: {
        show: false,
        active: [],
        default: [],
        all: [],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: ["created DESC"],
    };
  }

  componentDidMount() {
    this.setDefaultFilters();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.setDefaultFilters();
    }
  }

  setDefaultFilters = async () => {
    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];

      filters.default.push({
        field: "report",
        compare: "EQL",
        value: this.props.itemId,
      });

      return filters;
    });
  };

  render() {
    return (
      <>
        <List
          listKey="reportReadyList"
          key={this.props.customListKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(
            this.state.filters.active.concat(this.state.filters.default)
          )}
          sort={JSON.stringify(this.state.sortings)}
          fields={JSON.stringify(this.state.fields.active)}
          limit={150}
          hideSinglePageNav={true}
          keyField="id"
          path="/report/ready/list"
          blocker={{ spinnerFixed: true, hAuto: true }}
        >
          <ReportRecentListItem
            nodeId={this.props.nodeId}
            mode={this.props.mode}
            itemMode={this.props.itemMode}
            itemId={this.props.itemId}
          />
        </List>
      </>
    );
  }
}
